const MONTHS = ["Ιανουάριος", "Φεβρουάριος", "Μάρτιος", "Απρίλιος", "Μάιος", "Ιούνιος", "Ιούλιος", "Αύγουστος", "Σεπτέμβριος", "Οκτώβριος", "Νοέμβριος", "Δεκέμβριος"];
const DAYS = ["Δευ", "Τρι", "Τετ", "Πεμ", "Παρ", "Σαβ", "Κυρ"];
const esc = (s) => String(s ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
const fmt = (d) => { const [y, m, dd] = d.split("-"); return `${dd}/${m}/${y}`; };
const compSummary = (c) => {
  if (!c) return "";
  const parts = [];
  if (c.sector_number) parts.push(`${c.sector_number}ο Τμήμα${c.sector_title ? ` · ${c.sector_title}` : ""}`);
  if (c.president) parts.push(`Πρόεδρος: ${c.president}`);
  const others = (c.regular || []).filter(n => n !== c.president);
  if (others.length) parts.push(`Μέλη: ${others.join(", ")}`);
  if ((c.alternate || []).length) parts.push(`Αναπλ.: ${c.alternate.join(", ")}`);
  if ((c.excluded || []).length) parts.push(`Εξαιρέθηκαν (Μονομελές ίδια ημέρα): ${c.excluded.join(", ")}`);
  return parts.join(" · ");
};

const monthCells = (year, month) => {
  const offset = (new Date(year, month, 1).getDay() + 6) % 7;
  const days = new Date(year, month + 1, 0).getDate();
  const cells = Array(offset).fill(null);
  for (let d = 1; d <= days; d++) cells.push(d);
  while (cells.length % 7) cells.push(null);
  return cells;
};

// Εκτύπωση Ημερολογίου Έδρας σε νέο παράθυρο (μηνιαίο πλέγμα + αναλυτική λίστα)
export const printBenchCalendar = ({ year, month, entries, filters, privacyFn }) => {
  const byDate = entries.reduce((acc, e) => { (acc[e.hearing_date] ||= []).push(e); return acc; }, {});
  const cells = monthCells(year, month);
  let gridRows = "";
  for (let i = 0; i < cells.length; i += 7) {
    gridRows += "<tr>" + cells.slice(i, i + 7).map(day => {
      if (!day) return '<td class="empty"></td>';
      const iso = `${year}-${String(month + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
      const items = (byDate[iso] || []).map(e => e.unassigned
        ? `<div class="chip red"><b>${esc(e.pinakio_label)}</b> · ${e.case_count} υποθ.<br/><span class="j">ΧΩΡΙΣ ΔΙΚΑΣΤΗ ΕΔΡΑΣ</span></div>`
        : e.is_composition
          ? `<div class="chip violet"><b>${esc(e.pinakio_label)}</b> · ${e.case_count} υποθ.<br/><span class="j">Σύνθεση ${esc(e.composition?.label)}: ${esc(compSummary(e.composition))}</span></div>`
          : `<div class="chip"><b>${esc(e.pinakio_label)}</b> · ${e.case_count} υποθ.<br/><span class="j">${esc(e.judge)}</span></div>`).join("");
      const red = (byDate[iso] || []).some(e => e.unassigned) ? " red" : "";
      return `<td class="${items ? "has" + red : ""}"><div class="d">${day}</div>${items}</td>`;
    }).join("") + "</tr>";
  }
  const list = entries.map(e => `
    <h3 class="${e.unassigned ? "red" : e.is_composition ? "violet" : ""}">${fmt(e.hearing_date)} — ${esc(e.pinakio_label)} <span class="muted">(${esc(e.court_type)})</span> — ${e.unassigned ? "<b>ΧΩΡΙΣ ΔΙΚΑΣΤΗ ΕΔΡΑΣ</b>" : e.is_composition ? `Σύνθεση <b>«${esc(e.composition?.label)}»</b> — ${esc(compSummary(e.composition))}` : `Δικαστής Έδρας: <b>${esc(e.judge)}</b>`} — ${e.case_count} υποθ.</h3>
    <table class="cases"><thead><tr><th style="width:110px">ΓΑΚ</th><th style="width:90px">ΕΑΚ</th><th>Αντικείμενο</th><th style="width:180px">Δικ. Προδικαστικού</th></tr></thead>
    <tbody>${e.cases.map(c => `<tr><td class="mono">${esc(c.gak)}</td><td class="mono">${esc(c.eak || "—")}</td><td>${esc(privacyFn ? privacyFn(c.subject) : c.subject)}</td><td>${esc(c.pretrial_judge || "—")}</td></tr>`).join("")}
    ${e.case_count > e.cases.length ? `<tr><td colspan="4" class="muted">… και ${e.case_count - e.cases.length} ακόμη</td></tr>` : ""}</tbody></table>`).join("");

  const w = window.open("", "_blank");
  if (!w) return false;
  w.document.write(`<!DOCTYPE html><html lang="el"><head><meta charset="utf-8"><title>Ημερολόγιο Έδρας — ${MONTHS[month]} ${year}</title>
  <style>
    body { font-family: 'Segoe UI', Arial, sans-serif; margin: 20px; color: #222; font-size: 12px; }
    h1 { font-size: 18px; margin: 0 0 4px; } h2 { font-size: 13px; color: #666; margin: 0 0 14px; font-weight: normal; }
    h3 { font-size: 12px; margin: 14px 0 4px; background: #fef3c7; padding: 5px 8px; border: 1px solid #f59e0b; }
    table.grid { width: 100%; border-collapse: collapse; table-layout: fixed; margin-bottom: 18px; }
    table.grid th { background: #1e293b; color: #fff; padding: 5px; font-size: 11px; }
    table.grid td { border: 1px solid #cbd5e1; vertical-align: top; height: 72px; padding: 3px; }
    table.grid td.empty { background: #f8fafc; } table.grid td.has { background: #fffbeb; }
    .d { font-weight: bold; font-size: 11px; color: #64748b; } td.has .d { color: #92400e; }
    .chip { font-size: 10px; border: 1px solid #f59e0b; background: #fff; padding: 2px 3px; margin-top: 2px; line-height: 1.25; }
    .chip.red { border: 2px solid #dc2626; color: #991b1b; } table.grid td.red { outline: 2px solid #dc2626; outline-offset: -2px; }
    h3.red { background: #fee2e2; border-color: #dc2626; color: #991b1b; }
    .chip.violet { border-color: #7c3aed; } h3.violet { background: #ede9fe; border-color: #7c3aed; color: #4c1d95; }
    .j { color: #555; }
    table.cases { width: 100%; border-collapse: collapse; }
    table.cases th { background: #f1f5f9; border: 1px solid #ccc; padding: 4px 6px; text-align: left; font-size: 11px; }
    table.cases td { border: 1px solid #ddd; padding: 3px 6px; }
    .mono { font-family: monospace; font-weight: bold; } .muted { color: #777; font-weight: normal; }
    @media print { body { margin: 8mm; } h3 { page-break-after: avoid; } table.cases { page-break-inside: auto; } tr { page-break-inside: avoid; } }
  </style></head><body>
  <h1>Ημερολόγιο Έδρας — ${MONTHS[month]} ${year}</h1>
  <h2>${esc(filters)} · ${entries.length} δικάσιμοι/πινάκια · ${entries.reduce((s, e) => s + e.case_count, 0)} υποθέσεις${entries.some(e => e.unassigned) ? ` · <span style="color:#dc2626;font-weight:bold">${entries.filter(e => e.unassigned).length} χωρίς δικαστή έδρας</span>` : ""}</h2>
  <table class="grid"><thead><tr>${DAYS.map(d => `<th>${d}</th>`).join("")}</tr></thead><tbody>${gridRows}</tbody></table>
  ${list || '<p class="muted">Καμία δικάσιμος έδρας για τον μήνα.</p>'}
  <script>window.onload=function(){window.print();}</script>
  </body></html>`);
  w.document.close();
  return true;
};
